export default __webpack_public_path__ + "finsuite-icon.167014f2.svg";